import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import { I18n } from "@aws-amplify/core";
import update from "immutability-helper";
//import { get } from "lodash";

import { fetchPut } from "../../../api/fetch";

import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";

import DetailsContainer from "../../Common/DetailsContainer";
import CustomButton from "../../Common/CustomButton";
import InfoSection from "../../Common/InfoSection";
import FormSection from "../../Common/FormSection";
import Timeline from "../Timeline";
//import MeasuredTemperature from "../Temperature/MeasuredTemperature";
import MatchSuccess from "../MatchSuccess";

import { getAttributeName } from "../../../utils/attributes";
import { getLov } from "../../../utils/lov";
import {
  updateOneLog,
  updateFilteredLogs,
} from "../../../actions/siteEntranceExit/tabs";

import { driveInOut, walkInOut } from "../../../constants/reducers";

import images from "../../../assets/img/images";

const styles = (theme) => ({
  timelineCol: {
    [theme.breakpoints.up("lg")]: {
      marginRight: "50px",
    },
    [theme.breakpoints.down("xl")]: {
      marginBottom: "20px",
    },
  },
});

const LogDetailsSummary = (props) => {
  const { classes, dispatch, log, language, tabs } = props;
  const [lov, setLov] = React.useState({});
  const [edition, setEdition] = React.useState(false);
  const [saving, setSaving] = React.useState(false);

  const fetchLov = async () => {
    setLov({
      riskLevel: await getLov("riskLevel"),
      status: await getLov("status"),
    });
  };

  const handleChange = (id, index, value) => {
    setEdition(
      update(edition, {
        [id]: { $set: value },
      })
    );
  };

  const submit = async () => {
    try {
      setSaving(true);
      let body = {};
      if (edition.status) body.status = parseInt(edition.status);
      if (edition.riskLevel) body.risk_level = parseInt(edition.riskLevel);
      if (edition.comments !== undefined) body.description = edition.comments;
      if (edition.active !== undefined) body.active = edition.active;
      await fetchPut(`event_groups/${log.id}`, body);
      await dispatch(
        updateOneLog(props.section, tabs.tabIndex, tabs.openFrom, log.id)
      );
      dispatch(updateFilteredLogs(props.section));
      setEdition(false);
      setSaving(false);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Grid container>
      <Grid
        item
        xs={3}
        style={{
          padding: "0px 24px 24px 24px",
          marginRight: "20px",
          maxWidth: "300px",
        }}
      >
        <Grid container direction="column">
          <Grid item>
            <Grid container wrap="wrap-reverse">
              {edition ? (
                <Grid
                  item
                  className="bold-500"
                  style={{
                    padding: "0px 8px 8px 0px",
                    margin: "-2px 0px 0px -4px",
                  }}
                >
                  <Checkbox
                    color="primary"
                    checked={
                      edition.active !== undefined
                        ? edition.active
                        : props.log.main.active
                    }
                    onChange={(e) =>
                      handleChange("active", null, e.target.checked)
                    }
                  />
                  {I18n.get("profiles_active")}
                </Grid>
              ) : (
                <InfoSection title="active" values={[props.log.main.active]} />
              )}
              <Grid
                item
                xs
                className="flexCenter"
                style={{ justifyContent: "flex-end", paddingBottom: "8px" }}
              >
                {edition ? (
                  saving ? (
                    <CircularProgress size={20} />
                  ) : (
                    <>
                      <CustomButton
                        color="primary"
                        style={{ margin: "0px 10px 0px 0px" }}
                        onClick={() => setEdition(false)}
                      >
                        {I18n.get("site_cancel")}
                      </CustomButton>
                      <CustomButton
                        variant="contained"
                        color="primary"
                        onClick={submit}
                      >
                        {I18n.get("site_save")}
                      </CustomButton>
                    </>
                  )
                ) : (
                  <img
                    src={images.editIconColored}
                    alt="edit"
                    style={{ cursor: "pointer" }}
                    onClick={async () => {
                      await fetchLov();
                      setEdition({});
                    }}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
          {edition ? (
            <FormSection
              style={{ padding: "8px", marginBottom: "0px" }}
              formValue={[
                edition.riskLevel !== undefined
                  ? edition.riskLevel
                  : lov.riskLevel
                      .filter(
                        (v) =>
                          v[`name_${language}`] === props.log.main.riskLevel
                      )
                      .map((v) => v.id),
              ]}
              setFormValue={handleChange}
              title="riskLevel"
              id="riskLevel"
              type="select"
              options={{
                options:
                  lov.riskLevel &&
                  lov.riskLevel.map((t) => ({
                    id: t.id.toString(),
                    name: t["name_" + language],
                  })),
              }}
            />
          ) : (
            <InfoSection
              title="riskLevel"
              values={[props.log.main.riskLevel]}
            />
          )}
          <InfoSection title="dateTime" values={[props.log.main.dateTime]} />
          {edition ? (
            <FormSection
              style={{ padding: "8px", marginBottom: "0px" }}
              formValue={[
                edition.status !== undefined
                  ? edition.status
                  : lov.status
                      .filter(
                        (v) => v[`name_${language}`] === props.log.main.status
                      )
                      .map((v) => v.id),
              ]}
              setFormValue={handleChange}
              title="status"
              id="status"
              type="select"
              options={{
                options:
                  lov.status &&
                  lov.status.map((t) => ({
                    id: t.id.toString(),
                    name: t["name_" + language],
                  })),
              }}
            />
          ) : (
            <InfoSection title="status" values={[props.log.main.status]} />
          )}
          {edition ? (
            <FormSection
              style={{ padding: "8px", marginBottom: "0px" }}
              formValue={[
                edition.comments !== undefined
                  ? edition.comments
                  : props.log.main.comments,
              ]}
              setFormValue={handleChange}
              title="comments"
              id="comments"
              options={{ multiline: true, height: "250px" }}
            />
          ) : (
            <InfoSection title="comments" values={[props.log.main.comments]} />
          )}
          <InfoSection title="logType" values={[props.log.main.logType]} />
          <InfoSection
            title2={getAttributeName(105)}
            values={[props.log.main.entryStatus]}
          />
          {/* <InfoSection
            title="modifiedOn"
            values={[props.log.main.modifiedOn]}
          /> */}
          {/* <InfoSection
            title="processedBy"
            values={[props.log.main.processedBy]}
          /> */}
        </Grid>
      </Grid>
      <Grid
        item
        className={props.section === walkInOut ? "MuiGrid-grid-xs-true" : ""}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            xl={6}
            style={{
              maxWidth: props.section === driveInOut ? "800px" : "550px",
              minWidth: "550px",
            }}
            className={classes.timelineCol}
          >
            <Timeline
              section={props.section}
              data={log.complete.timeline}
              eventGroupId={log.complete.id}
              log={log.complete}
            />
          </Grid>
          {/* {props.section === walkInOut && (
            <Grid
              item
              xs={12}
              xl={6}
              style={{
                maxWidth: props.section === driveInOut ? "800px" : "550px",
                minWidth: "550px",
                paddingTop: "8px",
              }}
            >
              <MeasuredTemperature
                data={get(log, ["measuredTemperature"])}
                startTime={get(log, ["complete", "timeline", 0, "timestamp"])}
                language={language}
              />
            </Grid>
          )} */}
        </Grid>
      </Grid>
      {props.section === driveInOut && (
        <Grid
          item
          style={{ padding: "0px 10px", minWidth: "330px", maxWidth: "330px" }}
        >
          <DetailsContainer
            title={I18n.get("site_matchSuccess")}
            style={{ paddingBottom: 0, paddingLeft: "5px" }}
          >
            <MatchSuccess data={log.complete.timeline} />
          </DetailsContainer>
        </Grid>
      )}
    </Grid>
  );
};

LogDetailsSummary.propTypes = {
  log: PropTypes.object.isRequired,
  language: PropTypes.any.isRequired,
  tabs: PropTypes.object,
};

export default connect()(withStyles(styles)(LogDetailsSummary));
